export function getToken(): string {
  try {
    return localStorage.getItem('token') || '';
  } catch {
    return '';
  }
}

export function getRole(): string {
  try {
    return localStorage.getItem('role') || '';
  } catch {
    return '';
  }
}

export function isLoggedin(): boolean {
  return !!getToken();
}

export function setToken(token: string): void {
  try {
    localStorage.setItem('token', token);
  } catch {
    /* ignore */
  }
}

export function clearAuth(): void {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
  } catch {
    /* ignore */
  }
}
